import { render, staticRenderFns } from "./Press.vue?vue&type=template&id=0bb6e582&scoped=true&lang=pug&"
import script from "./Press.vue?vue&type=script&lang=js&"
export * from "./Press.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb6e582",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bb6e582')) {
      api.createRecord('0bb6e582', component.options)
    } else {
      api.reload('0bb6e582', component.options)
    }
    module.hot.accept("./Press.vue?vue&type=template&id=0bb6e582&scoped=true&lang=pug&", function () {
      api.rerender('0bb6e582', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/blog/Press.vue"
export default component.exports